module.exports = __webpack_public_path__ + "img/meh-rolling-eyes.37c4d64d.svg";